module.exports = __webpack_public_path__ + "static/media/laddu_page01.4b2336e5.png";